"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "identifier", {
  enumerable: true,
  get: function get() {
    return _identifiers.IMAGEIX;
  }
});
Object.defineProperty(exports, "displayName", {
  enumerable: true,
  get: function get() {
    return _identifiers.IMAGEIX;
  }
});
Object.defineProperty(exports, "options", {
  enumerable: true,
  get: function get() {
    return _options["default"];
  }
});
exports["default"] = exports.Raw = exports.ThemedImage = void 0;

var _reactCssThemr = require("react-css-themr");

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _identifiers = require("../identifiers");

var _factory = _interopRequireDefault(require("./factory"));

var _options = _interopRequireDefault(require("./options"));

var _normal = _interopRequireDefault(require("./_normal.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import resizeHoc from '../../hoc/resize';


var factoryParams = {
  identifier: _identifiers.IMAGEIX,
  resizeDelay: 0,
  Img: _gatsbyImage["default"]
};
var Image = (0, _factory["default"])(factoryParams);
/** @component */

exports.Raw = Image;
var themed = (0, _reactCssThemr.themr)(_identifiers.IMAGEIX, _normal["default"])(Image); // const resized = resizeHoc()( themed );

exports.ThemedImage = themed;
var _default = themed;
exports["default"] = _default;